
//this is a contact center view

require('./sessionView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

class SessionView extends React.Component {
    constructor(props){
        super(props);
        this.handleShowHideError = this.handleShowHideError.bind(this);
        this.state = {
            showError: false
        }
    }

    handleShowHideError(){
        this.setState(previousState => {
            return { showError: !previousState.showError };
        });
    }

    buildContactCenterError(){
        const { immRegisteredLoginError } = this.props;
        const errorMessage = this.state.showError ? formatText('session-hideError'):formatText('session-showError')
        return (
            <div className="session-view__center-error">
                <p onClick={this.handleShowHideError} className="session-view__show-error-toogle">{errorMessage}</p>
                <dl className={`session-view__center-error-detail--show-${this.state.showError}`}>
                    <dt>{formatText('session-error')}</dt>
                    <dd>{immRegisteredLoginError.getIn(['error', 'error'])}</dd>
                    <dt>{formatText('session-errorDescription')}</dt>
                    <dd>{immRegisteredLoginError.getIn(['error', 'errorDescription'])}</dd>
                </dl>
            </div>
            );
    }

    buildCustomMessageBox(){
        const title = formatText('session-title');
        const extraContent = <p className="session-view__center-extra-content">{formatText('session-description')}</p>
        const errorDetailSection = __CONTACT_CENTER__? this.buildContactCenterError():null;
        return (
            <div>
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    extraContent={extraContent}
                />
                {errorDetailSection}
            </div>
        )
    }

    render(){
        return(
            <div>
                {this.buildCustomMessageBox()}
            </div>
        );
    }
}

SessionView.propTypes = {
    immRegisteredLoginError: PropTypes.object,
}

module.exports.SessionView = connect(
    state => ({
        immRegisteredLoginError: state.registerLoginError,
    })
)(SessionView);
